import { forwardRef } from 'react';
import { createPortal } from 'react-dom';
import { Alert, AlertProps } from '@mui/material';
import { CustomContentProps } from 'notistack';

const BasePortalSnackbar = forwardRef<HTMLDivElement, CustomContentProps & { severity: AlertProps['severity'] }>(({ message, severity }, ref) => {
  const content = (
    <div
      ref={ref}
      style={{
        position: 'relative',
        marginBottom: '8px',
        maxWidth: '400px',
        zIndex: 9999,
      }}
    >
      <Alert severity={severity} style={{ width: '100%' }} variant="filled">
        {message}
      </Alert>
    </div>
  );

  // Get or create the snackbar container
  let container = document.getElementById('snackbar-portal-container');
  if (!container) {
    container = document.createElement('div');
    container.id = 'snackbar-portal-container';
    container.style.position = 'fixed';
    container.style.bottom = '16px';
    container.style.right = '16px';
    container.style.zIndex = '9999';
    container.style.pointerEvents = 'none';
    document.body.appendChild(container);
  }

  return createPortal(content, container);
});

// Create specific components for each variant
export const SuccessPortalSnackbar = forwardRef<HTMLDivElement, CustomContentProps>(
  (props, ref) => <BasePortalSnackbar {...props} ref={ref} severity="success" />
);

export const ErrorPortalSnackbar = forwardRef<HTMLDivElement, CustomContentProps>(
  (props, ref) => <BasePortalSnackbar {...props} ref={ref} severity="error" />
);

export const WarningPortalSnackbar = forwardRef<HTMLDivElement, CustomContentProps>(
  (props, ref) => <BasePortalSnackbar {...props} ref={ref} severity="warning" />
);

export const InfoPortalSnackbar = forwardRef<HTMLDivElement, CustomContentProps>(
  (props, ref) => <BasePortalSnackbar {...props} ref={ref} severity="info" />
);

BasePortalSnackbar.displayName = 'BasePortalSnackbar';
SuccessPortalSnackbar.displayName = 'SuccessPortalSnackbar';
ErrorPortalSnackbar.displayName = 'ErrorPortalSnackbar';
WarningPortalSnackbar.displayName = 'WarningPortalSnackbar';
InfoPortalSnackbar.displayName = 'InfoPortalSnackbar';
